import produce from 'immer'
import { ADD_POST_ERROR, SET_POSTS_DATA } from './constants';

export const initialState = {
    error: null
}

const postReducer = (state = initialState, action) => 
    produce(state, (draft) => {
        // eslint-disable-next-line default-case
        switch (action.type) {
            case ADD_POST_ERROR:
                draft.error = action.error;
                break;
            case SET_POSTS_DATA:
                draft.postData = action.data;
                break;
        }
    })


export default postReducer;
